import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SLOT_LABELS } from "@/components/booking-form/registry/slotLabels";
import { Layers, RotateCcw } from "lucide-react";

const SlotLabelRow = ({ fd, slotKey, entry }) => {
  const key = `${slotKey}::${entry.name}`;
  const dirty = fd.isDirty("slot_label", key);
  const val = fd.effective("slot_label", key, "label", entry.label);
  return (
    <div className={`sm:col-span-12 grid grid-cols-12 gap-2 items-center py-1 ${dirty ? "bg-amber-50/40 rounded" : ""}`}
         data-testid={`fd-slot-label-row-${key}`}>
      <div className="col-span-4">
        <code className="text-[11px] text-slate-500">{entry.name}</code>
        <div className="text-[11px] text-slate-400 truncate">default: {entry.label}</div>
      </div>
      <div className="col-span-7">
        <Input value={val}
               onChange={(ev) => fd.setDraftValue("slot_label", key, "label", ev.target.value)}
               placeholder={entry.label}
               className="h-8 text-sm"
               data-testid={`fd-slot-label-input-${key}`} />
      </div>
      <div className="col-span-1 text-right">
        <Button size="sm" variant="ghost" className="h-7 w-7 p-0"
                onClick={() => fd.resetRow("slot_label", key)}
                disabled={!fd.savedFor("slot_label", key) && !dirty}
                title="Reset to default"
                data-testid={`fd-slot-label-reset-${key}`}>
          <RotateCcw className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
};

export const SlotLabelEditor = ({ fd, tabKey, slots }) => {
  const withLabels = slots.filter((s) => SLOT_LABELS[s.key]);
  if (!withLabels.length) return null;
  return (
    <div className="mb-2 pb-2 border-b border-slate-100" data-testid={`fd-slot-labels-${tabKey}`}>
      {withLabels.map((s) => {
        const entries = SLOT_LABELS[s.key] || [];
        return (
          <details key={s.key} className="bg-slate-50/50 rounded border border-slate-200 px-2 py-1 mb-1">
            <summary className="cursor-pointer text-xs text-slate-600 inline-flex items-center gap-1.5 py-1">
              <Layers className="h-3 w-3" />
              <span className="font-medium">{s.label || s.key}</span>
              <span className="text-slate-400">·</span>
              <span className="text-[11px] text-slate-500">{entries.length} editable labels</span>
            </summary>
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-2 pt-2 pl-1">
              {entries.map((e) => <SlotLabelRow key={e.name} fd={fd} slotKey={s.key} entry={e} />)}
            </div>
          </details>
        );
      })}
    </div>
  );
};
